
/** Use in layouts for being able to fill material svg Icons with our Oabat gradient. If icon wants to be in oabat gradient, just use class "oabat-gradient-icon"
 */
export default {
    name: "SVGGradient",
}
